const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const formatterWholeNum = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const messages = {
  'under50': 'Free Shipping On Orders Over $50',
  'over50': 'This Order Qualifies for Free Shipping!'
}

class variantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.variantChange);

    if (this.querySelector('[data-popout-list]')) {
      this.closest('form').querySelector('[name="id"]').addEventListener('change', this.variantChange);
    }
  }

  connectedCallback() {
    const container = this.closest('[data-product-info]');
    if (!container) return;

    const variantData = JSON.parse(this.querySelector('[data-variant-data]').textContent);
    const newVariantId = this.closest('form').querySelector('[name="id"]').value;
    const selectedVariant = variantData.find(obj => obj.id == newVariantId);
    if (!selectedVariant) return;

    const containerId = container.dataset.productInfo;
    const imageContainer = document.querySelector(`.bd-slider[data-id="${containerId}"]`);
    if (!imageContainer) return;

    const tryUpdate = () => {
      if (Flickity.data(imageContainer)) {
        this.updateImages(imageContainer, selectedVariant);
      } else {
        requestAnimationFrame(tryUpdate);
      }
    };
    requestAnimationFrame(tryUpdate);
  }

  variantChange(event) {
    const bdVariants = this.nodeName == "BD-VARIANTS" ? this : this.closest('form').querySelector('bd-variants');
    const container = bdVariants.closest('[data-product-info]');
    const variantData = JSON.parse(bdVariants.querySelector('[data-variant-data]').textContent);
    const newVariantId = bdVariants.closest('form').querySelector('[name="id"]').value;
    const selectedVariantArray = variantData.filter(obj => obj.id == newVariantId);
    const selectedVariant = selectedVariantArray[0];
    const messageArea = container.querySelector('[data-cta-messages]');

    const containerId = container.dataset.productInfo;
    const imageContainer = document.querySelector(`.bd-slider[data-id="${containerId}"]`);

    if (messageArea) {
      bdVariants.updateCTA(messageArea, selectedVariant);
    }

    // Update images immediately — no AJAX needed
    if (imageContainer) {
      bdVariants.updateImages(imageContainer, selectedVariant);
    }

    // Fetch fresh section HTML for accurate pricing (fixes discount price disappearing)
    bdVariants.fetchAndUpdatePrices(container, selectedVariant);
  }

  // --- NEW: AJAX price refresh via Section Rendering API ---
  async fetchAndUpdatePrices(container, selectedVariant) {
  const sectionId = this.getSectionId(container);

  if (!sectionId) {
    console.warn('bd-variants: No section ID found, falling back to local price update.');
    this.updatePrices(container, selectedVariant);
    return;
  }

  // Capture one-time radio state BEFORE the DOM swap
  const oneTimeRadio = container.querySelector('input[data-type="one-time"]');
  const oneTimeWasChecked = true; // Always reset to One Time on variant change

  const url = `${window.location.pathname}?section_id=${sectionId}&variant=${selectedVariant.id}`;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Section fetch failed: ${response.status}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Swap price container HTML
    const freshPriceContainer = doc.querySelector('[data-bd-price]');
    const livePriceContainer = container.querySelector('[data-bd-price]');
    if (freshPriceContainer && livePriceContainer) {
      livePriceContainer.innerHTML = freshPriceContainer.innerHTML;
    }

    // Swap CTA / add-to-cart price area
    const freshCta = doc.querySelector('[data-bd-add]');
    const liveCta = container.querySelector('[data-bd-add]');
    if (freshCta && liveCta) {
      liveCta.innerHTML = freshCta.innerHTML;
    }

    // Re-apply one-time radio selection after DOM replacement
    const newOneTimeRadio = container.querySelector('input[data-type="one-time"]');
    if (newOneTimeRadio) {
      newOneTimeRadio.checked = oneTimeWasChecked;

      if (oneTimeWasChecked) {
        // Ensure subscription toggle UI is reset to one-time state
        const subscriptionToggle = container.querySelector('.subscription-toggle');
        if (subscriptionToggle) {
          subscriptionToggle.removeAttribute('open');
          subscriptionToggle.classList.remove('subscription-toggle--selected');
        }
        const priceEl = container.querySelector('[data-bd-price] .price');
        if (priceEl) {
          priceEl.classList.remove('price--on-sale', 'subscription');
        }
      }
    }

    // Re-sync selling plan select options after DOM replacement
    this.updateSellingPlanOptions(container, selectedVariant);

    // ADD THIS:
    const subscriptionWidget = container.querySelector('subscription-select');
    if (subscriptionWidget) {
      const oneTimePrices = container.querySelectorAll('[data-one-time-price]');
      this.updateOneTimePrices(oneTimePrices, selectedVariant);

      const subscriptionPrices = container.querySelectorAll('[data-subscription-price]');
      this.updateSubscriptionPrices(subscriptionPrices, selectedVariant);

      if (theme.settings.enablePriceDiscount === true) {
        const discountPrices = container.querySelectorAll('[data-discount-price]');
        this.updateDiscountPrices(discountPrices, selectedVariant);
      }
    }

  } catch (err) {
    console.error('bd-variants: AJAX price refresh failed, using local fallback.', err);
    this.updatePrices(container, selectedVariant);
  }
}

  // Resolve the Shopify section ID from the nearest .shopify-section wrapper
  getSectionId(container) {
    const shopifySection = container.closest('[id^="shopify-section-"]');
    if (shopifySection) {
      return shopifySection.id.replace('shopify-section-', '');
    }
    // Fallback: check for an explicit data-section-id attribute
    const explicit = container.closest('[data-section-id]');
    if (explicit) return explicit.dataset.sectionId;
    return null;
  }

  // --- Unchanged below ---

  updateImages(imageContainer, selectedVariant) {
    const imageIndex = selectedVariant.featured_media.position;
    const variantImages = imageContainer.querySelectorAll('[data-variant]');
    const outerContainer = imageContainer.closest('.product-images-slides');
    const loader = outerContainer.querySelector('.loading__spinner');

    variantImages.forEach((image) => {
      if (image.dataset.variant == selectedVariant.option1) {
        image.classList.remove('hide');
      } else {
        image.classList.add('hide');
      }
    });

    const flkty = Flickity.data(imageContainer);

    flkty.on('select', function (index) {
      imageContainer.classList.add('opacity0');
      loader.classList.remove('hidden');
    });

    flkty.on('settle', function (index) {
      console.log('Settle on', index);
      flkty.resize();
      imageContainer.classList.remove('opacity0');
      loader.classList.add('hidden');
    });

    const totalSlides = flkty.slides.length;
    console.log('total slides', totalSlides);

    if (imageIndex == 1) {
      flkty.select(0);
    } else if (totalSlides < imageIndex) {
      flkty.select(totalSlides - 1);
    } else {
      flkty.select(imageIndex - variantImages.length - 1);
    }
  }

  updateCTA(messageArea, selectedVariant) {
    if (selectedVariant.price > 5000) {
      messageArea.innerHTML = messages.over50;
    } else {
      messageArea.innerHTML = messages.under50;
    }
  }

  // Kept as local fallback
  updatePrices(container, selectedVariant) {
    const priceContainer = container.querySelector('[data-bd-price]');
    const originalPrice = formatter.format(selectedVariant.price * 0.01);
    const oneTime = container.querySelector('[data-type="one-time"]');
    const oneTimePrice = container.querySelectorAll('[data-one-time-price]');
    const oneTimePriceInCtaForDiscountWhenNoMoreDataDiscountPrice = container.querySelector('[data-bd-add] [data-bd-price] .price');
    const discountPrice = oneTimePriceInCtaForDiscountWhenNoMoreDataDiscountPrice
      ? [...container.querySelectorAll('[data-discount-price]'), oneTimePriceInCtaForDiscountWhenNoMoreDataDiscountPrice]
      : container.querySelectorAll('[data-discount-price]');
    const subscriptionPrice = container.querySelectorAll('[data-subscription-price]');
    const isUpsellCard = container.classList.contains('upsell-card');

    this.updateSellingPlanOptions(container, selectedVariant);
    this.updateOneTimePrices(oneTimePrice, selectedVariant);

    if (theme.settings.enablePriceDiscount === true) {
      this.updateDiscountPrices(discountPrice, selectedVariant);
    }

    if (oneTime) {
      this.handleSubscriptionToggle(oneTime, priceContainer, selectedVariant, subscriptionPrice);
    } else if (isUpsellCard) {
      this.handleUpsellCardPricing(container, priceContainer, originalPrice, oneTimePrice, discountPrice, selectedVariant);
    } else {
      const price_regular = priceContainer.querySelector('.price-item--regular');
      if (!price_regular) return;
      price_regular.innerHTML = originalPrice;
    }
  }

  updateOneTimePrices(oneTimePrice, selectedVariant) {
    const variantPrice = formatter.format(selectedVariant.price * 0.01);
    const hasCompareAt = selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price;
    const compareAtFormatted = hasCompareAt ? formatter.format(selectedVariant.compare_at_price * 0.01) : null;

    oneTimePrice.forEach((priceEl) => {
      if (priceEl.closest('.subscription-toggle') || priceEl.closest('summary')) {
        priceEl.innerHTML = hasCompareAt ? compareAtFormatted : variantPrice;
      } else if (priceEl.closest('.single-payment') && hasCompareAt) {
        priceEl.innerHTML = `<s>${compareAtFormatted}</s>`;
        let discountEl = priceEl.parentElement.querySelector('[data-discount-price]');
        if (!discountEl) {
          discountEl = document.createElement('span');
          discountEl.setAttribute('data-discount-price', '');
          priceEl.insertAdjacentElement('afterend', discountEl);
        }
        discountEl.innerHTML = variantPrice;
        discountEl.style.display = '';
      } else {
        priceEl.innerHTML = variantPrice;
        const discountEl = priceEl.parentElement.querySelector('[data-discount-price]');
        if (discountEl && discountEl.closest('.single-payment') && this.isProductExcluded()) {
          discountEl.remove();
        }
      }
    });
  }

  isProductExcluded() {
    const excludeArr = theme.settings.excludeFromDiscount.split(',').map(item => item.toLowerCase().trim());
    return excludeArr.some(item => item && theme.settings.productTitle.toLowerCase() === item);
  }

  updateDiscountPrices(discountPrice, selectedVariant) {
    const discountAmount = (100 - theme.settings.discountAmount) / 100;
    const excluded = this.isProductExcluded();

    discountPrice.forEach((price) => {
      if (excluded && price.closest('.single-payment')) return;
      const originalPrice = formatter.format((selectedVariant.price * 0.01) * discountAmount);
      price.innerHTML = originalPrice;
    });
  }

  handleSubscriptionToggle(oneTime, priceContainer, selectedVariant, subscriptionPrice) {
    if (oneTime.checked) {
      this.setOneTimeMode(priceContainer);
      this.applyOneTimeExclusions(priceContainer, selectedVariant);
    } else {
      this.setSubscriptionMode(priceContainer, selectedVariant);
    }
    this.updateSubscriptionPrices(subscriptionPrice, selectedVariant);
  }

  setOneTimeMode(priceContainer) {
    const details = this.querySelector('.subscription-toggle');
    priceContainer.querySelector('.price').classList.remove('price--on-sale', 'subscription');
    if (details) {
      details.removeAttribute('open');
      details.classList.remove('subscription-toggle--selected');
    }
  }

  getVariantAllocation(selectedVariant) {
    if (!selectedVariant.selling_plan_allocations || selectedVariant.selling_plan_allocations.length === 0) {
      return null;
    }
    const container = document.querySelector('subscription-select');
    const selectEl = container ? container.querySelector('.subscription-select') : null;
    const selectedPlanId = selectEl ? selectEl.value : null;

    if (selectedPlanId) {
      const match = selectedVariant.selling_plan_allocations.find(
        a => String(a.selling_plan_id) === String(selectedPlanId)
      );
      if (match) return match;
    }
    return selectedVariant.selling_plan_allocations[0];
  }

  updateSellingPlanOptions(container, selectedVariant) {
    const subscriptionSelect = container.querySelector('subscription-select');
    if (!subscriptionSelect) return;

    const selectElement = subscriptionSelect.querySelector('.subscription-select');
    if (!selectElement) return;

    const validPlanIds = (selectedVariant.selling_plan_allocations || []).map(a => String(a.selling_plan_id));

    let firstValidOption = null;
    let currentIsValid = false;

    Array.from(selectElement.options).forEach(option => {
      const isValid = validPlanIds.includes(option.value);
      option.hidden = !isValid;
      option.disabled = !isValid;
      if (isValid && !firstValidOption) firstValidOption = option;
      if (isValid && option.selected) currentIsValid = true;
    });

    if (!currentIsValid && firstValidOption) {
      selectElement.value = firstValidOption.value;
    }

    const radios = subscriptionSelect.querySelectorAll('.subscription-input');
    radios.forEach(radio => { radio.checked = false; });
    if (selectElement.value) {
      const matchingRadio = subscriptionSelect.querySelector(`#selling_plan_${selectElement.value}`);
      if (matchingRadio) matchingRadio.checked = true;
    }
  }

  setSubscriptionMode(priceContainer, selectedVariant) {
    const allocation = this.getVariantAllocation(selectedVariant);
    if (!allocation) return;
    const price = formatter.format(allocation.price * 0.01);
    priceContainer.querySelector('.price').classList.add('price--on-sale', 'subscription');
    priceContainer.querySelector('.price--on-sale').innerHTML = price;
  }

  updateSubscriptionPrices(subscriptionPrice, selectedVariant) {
    const allocation = this.getVariantAllocation(selectedVariant);
    if (!allocation) return;
    subscriptionPrice.forEach((price) => {
      price.innerHTML = formatter.format(allocation.price * 0.01);
    });
  }

  applyOneTimeExclusions(priceContainer, selectedVariant) {
    const excludeArr = theme.settings.excludeFromDiscount.split(',').map(item => item.toLowerCase().trim());
    const originalPrice = formatter.format(selectedVariant.price * 0.01);

    excludeArr.forEach(item => {
      if (theme.settings.productTitle.toLowerCase() === item || theme.settings.enablePriceDiscount === false) {
        const priceElement = priceContainer.querySelector('.price-item--regular')
          ? priceContainer.querySelector('.price-item--regular')
          : priceContainer.querySelector('.price');
        priceElement.innerHTML = originalPrice;
      }
    });
  }

  handleUpsellCardPricing(container, priceContainer, originalPrice, oneTimePrice, discountPrice, selectedVariant) {
    oneTimePrice.forEach((price) => {
      price.innerHTML = originalPrice;
    });

    if (theme.settings.enablePriceDiscount === true) {
      this.updateDiscountPrices(discountPrice, selectedVariant);
    }

    const excludeArr = theme.settings.excludeFromDiscount.split(',').map(item => item.toLowerCase().trim());
    excludeArr.forEach(item => {
      if (container.querySelector('.product-name').innerHTML.toLowerCase() === item || theme.settings.enablePriceDiscount === false) {
        priceContainer.querySelector('.price-item--regular').innerHTML = originalPrice;
      }
    });
  }
}
customElements.define('bd-variants', variantSelects);


class SubscriptionSelects extends HTMLElement {
  constructor() {
    super();
    const details = this.querySelector('.subscription-toggle');
    details.addEventListener('click', this.onSubscriptionSelect);
    this.addEventListener('change', this.onSubscriptionSelect);
    details.addEventListener('toggle', this.onDetailsOpen);

    const selectElement = this.querySelector('.subscription-select');
    if (selectElement) {
      selectElement.addEventListener('change', () => {
        const allRadios = this.querySelectorAll('.subscription-input');
        allRadios.forEach(radio => radio.checked = false);

        const selectedRadio = this.querySelector(`#selling_plan_${selectElement.value}`);
        if (selectedRadio) {
          selectedRadio.checked = true;
          selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    this.filterInitialSellingPlans();

    // ✅ FIX: Always pre-select One Time on load
    const oneTimeRadio = this.querySelector('input[data-type="one-time"]');
    if (oneTimeRadio) {
      oneTimeRadio.checked = true;
      details.removeAttribute('open');
    }
  }

  filterInitialSellingPlans() {
    const selectEl = this.querySelector('.subscription-select') || this.querySelector('select.subscription-input');
    if (!selectEl) return;

    const formId = this.dataset.form;
    const form = formId ? document.getElementById(formId) : null;
    const variantInput = form ? form.querySelector('[name="id"]') : null;
    if (!variantInput) return;

    const variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    const selectedVariant = variantData.find(v => String(v.id) === String(variantInput.value));
    if (!selectedVariant || !selectedVariant.selling_plan_allocations) return;

    const validPlanIds = selectedVariant.selling_plan_allocations.map(a => String(a.selling_plan_id));

    let firstValidOption = null;
    Array.from(selectEl.options).forEach(option => {
      const isValid = validPlanIds.includes(option.value);
      option.hidden = !isValid;
      option.disabled = !isValid;
      if (isValid && !firstValidOption) firstValidOption = option;
    });

    if (firstValidOption) {
      selectEl.value = firstValidOption.value;
    }

    const radios = this.querySelectorAll('.subscription-input[type="radio"]');
    radios.forEach(radio => { radio.checked = false; });
    if (selectEl.value) {
      const matchingRadio = this.querySelector(`#selling_plan_${selectEl.value}`);
      if (matchingRadio) matchingRadio.checked = true;
    }
  }

  onDetailsOpen(element) {
    console.log('OPEN DETAILS', element);
    if (element.target.open == true) {
      const oneTimeRadio = document.querySelector('input[data-type="one-time"]');
      if (oneTimeRadio) {
        oneTimeRadio.checked = false;
      }

      const selectElement = this.querySelector('.subscription-select');
      if (selectElement) {
        selectElement.dispatchEvent(new Event('change'));
      }
    }
  }

  onSubscriptionSelect(element) {
    const target = this.nodeName == "SUBSCRIPTION-SELECT" ? this : this.closest('subscription-select');
    const container = target.closest('[data-product-info]');

    const formId = target.dataset.form;
    const form = document.getElementById(formId);
    const priceContainer = container.querySelector('[data-bd-price]');
    const qty = container.querySelector(`[data-quantity-input]`).value;
    const variantData = JSON.parse(target.querySelector('[type="application/json"]').textContent);
    const variantId = container.querySelector('[name="id"]').value;
    const bundlePriceOverride = target.querySelector('[data-bundle-price-override]')
      ? JSON.parse(target.querySelector('[data-bundle-price-override]').textContent)
      : null;
    const selectedVariantArray = variantData.filter(obj => obj.id == variantId);
    const selectedVariant = selectedVariantArray[0];
    const oneTimePrice = container.querySelector('[data-one-time-price]');

    if (element.target.dataset.type === 'one-time') {
      const discountPrice = target.querySelector('[data-discount-price]')
        ? target.querySelector('[data-discount-price]').innerHTML
        : null;
      const originalPrice = bundlePriceOverride
        ? bundlePriceOverride.bundle_price
        : formatter.format(selectedVariant.price * 0.01);
      const priceToDisplay = discountPrice ? discountPrice : originalPrice;

      const details = target.querySelector('.subscription-toggle') ? target.querySelector('.subscription-toggle') : '';
      if (priceContainer.querySelector('.price')) {
        priceContainer.querySelector('.price').classList.remove('price--on-sale', 'subscription');
        priceContainer.querySelector('.price').innerHTML = priceToDisplay;
      }

      if (details) {
        details.removeAttribute('open');
        details.classList.remove('subscription-toggle--selected');

        const excludeArr = theme.settings.excludeFromDiscount.split(',').map(item => item.toLowerCase().trim());
        excludeArr.forEach(item => {
          if (theme.settings.productTitle.toLowerCase() === item || theme.settings.enablePriceDiscount === false) {
            if (priceContainer.querySelector('.price-item--regular')) {
              priceContainer.querySelector('.price-item--regular').innerHTML = originalPrice;
            }
          }
        });
      }
      if (priceContainer.querySelector('[data-normal-pricing]')) {
        priceContainer.querySelector('[data-normal-pricing]').classList.remove('hide');
      }
      if (form.querySelector('.product-buttons')) {
        form.querySelector('.product-buttons').classList.remove('inactive');
      }
      const selectElement = this.querySelector('.subscription-select');
      if (selectElement) {
        const allRadios = this.querySelectorAll('.subscription-input');
        allRadios.forEach(radio => radio.checked = false);
      }
    } else {
      const selectElement = target.querySelector('.subscription-select');
      const selectedPlanId = selectElement ? selectElement.value : null;
      let allocation = null;
      if (selectedVariant.selling_plan_allocations && selectedVariant.selling_plan_allocations.length > 0) {
        if (selectedPlanId) {
          allocation = selectedVariant.selling_plan_allocations.find(
            a => String(a.selling_plan_id) === String(selectedPlanId)
          );
        }
        if (!allocation) {
          allocation = selectedVariant.selling_plan_allocations[0];
        }
      }
      const price = allocation
        ? formatter.format(allocation.price * 0.01)
        : formatter.format(selectedVariant.price * 0.01);

      const oneTimeRadio = document.querySelector('input[data-type="one-time"]');
      if (oneTimeRadio) {
        oneTimeRadio.checked = false;
      }

      if (priceContainer.querySelector('.price')) {
        priceContainer.querySelector('.price').classList.add('price--on-sale', 'subscription');
        priceContainer.querySelector('.price--on-sale').innerHTML = price;
      }
      if (priceContainer.querySelector('.price-item--sale')) {
        priceContainer.querySelector('.price-item--sale').innerHTML = price;
      }

      const subscription_toggle = document.querySelector('.subscription-toggle');
      if (subscription_toggle) {
        subscription_toggle.classList.add('subscription-toggle--selected');
      }

      const subSelectEl = this.querySelector('.subscription-select');
      if (subSelectEl) {
        const allRadios = this.querySelectorAll('.subscription-input');
        allRadios.forEach(radio => radio.checked = false);

        const selectedRadio = this.querySelector(`#selling_plan_${subSelectEl.value}`);
        if (selectedRadio) {
          selectedRadio.checked = true;
        }
      }
    }
  }
}
customElements.define('subscription-select', SubscriptionSelects);


window.addEventListener('scroll', debounce(function () {
  spinBowl();

  if (window.scrollY > windowHeight() + 100) {
    document.querySelector('body').classList.add('showFloat');
  } else {
    document.querySelector('body').classList.remove('showFloat');
  }
}, 10));

function spinBowl() {
  const bowlImage = document.querySelector('.bowl-image');
  let rotation = 0;
  let scrollBefore = 0;
  const newScroll = window.scrollY;
  const scrollDiff = scrollBefore - newScroll;
  rotation += scrollDiff;
  scrollBefore = newScroll;
}

const upsellBlockATC = () => {
  const upsellTabsForm = document.querySelectorAll('bd-upsells .tab-content form');
  if (upsellTabsForm.length < 1) return;

  upsellTabsForm.forEach(form => {
    const selector = form.querySelector('.select__select');
    const hiddenInput = form.querySelector('[name="id"]');
    const variantDataScript = form.querySelector('[data-variant-data]');

    if (!selector || !hiddenInput || !variantDataScript) return;

    const variantData = JSON.parse(variantDataScript.innerHTML);

    selector.addEventListener('change', () => {
      const selectedVariant = variantData.find(variant => variant.option1 == selector.value);
      if (selectedVariant) {
        hiddenInput.value = selectedVariant.id;
      }
    });
  });
};
document.addEventListener('DOMContentLoaded', upsellBlockATC);
document.addEventListener('shopify:section:load', upsellBlockATC);